<div class="progress-bar-wrapper">
  <div class="progress-bar-title"><span class="usedDiskSpace memory-size"></span><span class="property-title">Disk Space</span><span class="totalDiskSpace memory-size"></span></div>
  <div class="progress-bar-custom" style="--width: 0 ; --pseudoEl: 'lightgreen'" [ngStyle]="{'--width' : progressWidth, 'background-color' : color}">
  </div>
</div>
